export const SURVICATE_URL_WORKSPACE_SCRIPT =
  'https://survey.survicate.com/workspaces/9cd0d9cb3823f32f6cb3492eb6e7d1e4/web_surveys.js';
